import { useContentConfig } from '@ad-lucy/context/adData';
import { type MouseEvent, useCallback } from 'react';

import type { NavigatorsToDefaultLinkOut } from './types';
import { useWindowOpen } from './useWindowOpen';

export const PreventDefaultLinkOutAttribute = 'data-prevent-default-link-out';

const isLink = (element: HTMLElement): boolean =>
  Boolean(element.tagName === 'A' && element.getAttribute('href'));

const hasLinkInDomPath = (element: HTMLElement): boolean => {
  if (isLink(element)) {
    return true;
  }
  if (element.parentElement) {
    return hasLinkInDomPath(element.parentElement);
  }
  return false;
};

export function useDefaultLinkOut(): NavigatorsToDefaultLinkOut {
  const { windowOpen } = useWindowOpen();
  const { data: contentConfig } = useContentConfig();
  const linkOutDefault = contentConfig?.general?.linkOutDefault;
  const openDefaultLink = useCallback(
    (target: HTMLElement) => {
      const preventDefaultLinkOutAttr = target.getAttribute(PreventDefaultLinkOutAttribute);
      const preventDefaultLinkOut =
        preventDefaultLinkOutAttr && preventDefaultLinkOutAttr !== 'false';
      // Don't open defaultLinkOut if the target is a link
      const hasLink = hasLinkInDomPath(target);

      if (!preventDefaultLinkOut && !hasLink && linkOutDefault) {
        windowOpen(linkOutDefault);
      }
    },
    [linkOutDefault, windowOpen],
  );

  const openDefaultLinkOn = useCallback(
    (e: MouseEvent) => {
      openDefaultLink(e.target as unknown as HTMLElement);
    },
    [openDefaultLink],
  );

  return {
    openDefaultLinkOn,
    openDefaultLink,
  };
}
